import * as yup from 'yup';
import * as _ from 'lodash';
import * as moment from 'moment';
import { useFormik } from 'formik';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { useEffect, useMemo, useRef, useState } from 'react';
import { SERVER_URL } from '../../../constants';
import * as actions from '../../../redux/actions';
import { mapPostToNewsItem } from '../post.mapper';
import { TextField } from '../../common/FormFields';
import * as selectors from '../../../redux/selectors';
import PageContainer from '../../common/PageContainer';
import { promoAlertStyleOptions } from '../email.constants';
import { DateInput, DateTimeInput } from 'semantic-ui-calendar-react';
import * as $ from 'jquery';
import {
  Breadcrumb,
  Button,
  Container,
  Dropdown,
  Form,
  Grid,
  Header,
  Image,
  Label,
  Menu,
  Message,
  Popup,
  Segment,
  Select,
} from 'semantic-ui-react';
import PhotoSearch from '../../photos/PhotoSearch';
import MailChimpSection from '../MailChimpSection';
import toast from 'react-hot-toast';
import * as campaignApi from './../../../api/campaignApi';
import { getQuill, QUILL_TOOLBAR } from '../../quill';
import { ChromePicker } from 'react-color';
import {
  buildPromoAlertData,
  CITY_RINK_DEFAULT_BUTTON_COLOR,
  CITY_RINK_DEFAULT_BUTTON_TEXT_COLOR,
  CITY_RINK_DEFAULT_BUTTON_URL,
  getPromoAlertTemplateId,
  getPromoAlertPublicationValues,
  shouldHydratePromoAlert,
} from './promoAlertForm';
const ReactQuill = getQuill();

const ColorPickerField = ({ name, label, help, value, defaultColor, error, errorMessage, setFieldValue, errorStyle }) => (
  <Form.Field required error={error}>
    <label>{label}</label>
    <Popup
      on="click"
      position="bottom left"
      flowing
      trigger={
        <Button
          type="button"
          aria-label={`Open ${label.toLowerCase()} picker`}
          title="Choose a color"
          style={{
            width: 52,
            height: 38,
            minWidth: 52,
            padding: 2,
            border: '1px solid rgba(34, 36, 38, 0.2)',
            backgroundColor: value || defaultColor,
          }}
        />
      }
      content={
        <ChromePicker
          color={value || defaultColor}
          disableAlpha
          onChange={color => setFieldValue(name, color.hex)}
        />
      }
    />
    <div id={`${name}-help`} style={{ marginTop: 4, color: '#666' }}>
      {help}
    </div>
    {error && (
      <Label
        id={`${name}-error`}
        role="alert"
        basic
        style={errorStyle}
        pointing
        content={errorMessage}
      />
    )}
  </Form.Field>
);

const AddPromoAlert = ({
  sites,
  addPromoAlert,
  getSites,
  history,
  clearRecentPosts,
  topPostResults,
  deletePromoAlertById,
  match,
  user,
  getPromoAlertById,
  currentPromoAlert,
  updatePromoAlert,
  clonePromoAlert,
  findTemplate,
  getPromoAlertTestEmail,
  dallasId,
  campaignType = 'Promo Alert',
}) => {
  const id = match.params.id;
  const isCityRink = campaignType === 'City Rink';
  const sectionTitle = isCityRink ? 'City Rink' : 'Promo Alerts';
  const emailTitle = isCityRink ? 'City Rink Email' : 'Promo Alert';
  const basePath = isCityRink ? '/city-rink' : '/promo-alert';
  const [loading, setLoading] = useState(false);
  const [showValidationErrors, setShowValidationErrors] = useState(false);
  const hydratedPromoAlertId = useRef();
  const quill = useRef();

  const validationSchema = yup.object({
    style: yup.string().required('You must select a style'),
    siteId: yup
      .string()
      .required(isCityRink ? 'The Dallas site is required for City Rink emails.' : 'You must select a site')
      .test(
        'city-rink-site',
        'The Dallas site is unavailable. Contact an administrator before saving.',
        value => !isCityRink || Boolean(dallasId && value === dallasId)
      )
      .nullable(),
    subject: yup
      .string()
      .max(50, 'Subject must be at most 50 characters.')
      .required('A subject is required')
      .nullable(),
    title: yup.string().max(60, 'Title must be at most 60 characters.').nullable(),
    photoUrl: yup.string().optional().nullable(),
    buttonLabel: yup.string().optional().nullable(),
    buttonUrl: isCityRink
      ? yup.string().url('Enter a valid button URL.').required('A button URL is required.')
      : yup.string().optional().nullable(),
    buttonColor: isCityRink
      ? yup
          .string()
          .matches(/^#[0-9a-f]{6}$/i, 'Enter a six-digit hex color, such as #c6e300.')
          .required('A button color is required.')
      : yup.string().optional().nullable(),
    buttonTextColor: isCityRink
      ? yup
          .string()
          .matches(/^#[0-9a-f]{6}$/i, 'Choose a valid button text color.')
          .required('A button text color is required.')
      : yup.string().optional().nullable(),
    body: yup.string().nullable(),
    sendDate: yup.string().required('A send date is required').nullable(),
  });

  const UTM_MAP = {
    null: 'promo-alert',
    undefined: 'promo-alert',
    'Promo Alert': 'promo-alert',
    'Insider Invite': 'insider-invite',
    'City Rink': 'city-rink',
  };

  const modules = useMemo(() => QUILL_TOOLBAR(quill), [quill]);

  const start = moment().hour(0).minute(0).second(0).millisecond(0);
  const EMAIL_SEND_TIMES = _.range(0, 96).map(t => {
    const time = start.clone().add(t * 15, 'minutes');
    return {
      key: time.clone().add(15, 'minutes').format('HH:mm a'),
      value: time.clone().add(15, 'minutes').format('HH:mm:ss'),
      text: time.clone().add(15, 'minutes').format('hh:mm A'),
    };
  });

  const getUtm = style => `utm_source=${UTM_MAP[style]}&utm_medium=email&utm_campaign=website`;

  const errorStyle = { color: '#9f3a38', border: '1px solid #e0b4b4!important' };

  const initialValues = {
    style: isCityRink ? 'City Rink' : 'Promo Alert',
    subject: '',
    title: '',
    photoUrl: '',
    buttonLabel: '',
    buttonUrl: isCityRink ? CITY_RINK_DEFAULT_BUTTON_URL : '',
    buttonColor: isCityRink ? CITY_RINK_DEFAULT_BUTTON_COLOR : '',
    buttonTextColor: isCityRink ? CITY_RINK_DEFAULT_BUTTON_TEXT_COLOR : '',
    body: '',
    trendingNews: [],
    trendingEvents: [],
    trendingPlaces: [],
    siteId: '',
    startDate: '',
    endDate: '',
    photoType: 'No crop',
    sendDate: '',
    sendTime: '',
    utm: getUtm(currentPromoAlert?.style),
  };

  const handleSubmit = (digest, formik) => {
    const data = buildPromoAlertData(digest, { id, isCityRink, dallasId });

    id ? updatePromoAlert(data) : addPromoAlert(data);
  };

  const formik = useFormik({
    enableReinitialize: false,
    onSubmit: handleSubmit,
    initialValues,
    validationSchema,
    validateOnChange: false,
    validateOnBlur: false,
  });

  useEffect(() => {
    if (!id) return;
    getPromoAlertById(id);
  }, [id]);

  useEffect(() => {
    if (!shouldHydratePromoAlert(id, currentPromoAlert?.id, hydratedPromoAlertId.current)) return;

    hydratedPromoAlertId.current = id;
    formik.resetForm({ values: getPromoAlertPublicationValues(currentPromoAlert, isCityRink) });
  }, [currentPromoAlert, id, isCityRink]);

  useEffect(() => {
    clearRecentPosts();
  }, []);

  useEffect(() => {
    if (!loading && id) return;
    setLoading(false);
    formik.setFieldValue('trendingNews', _.chain(topPostResults).take(3).map(mapPostToNewsItem).value());
  }, [topPostResults]);

  useEffect(() => {
    formik.setFieldValue('utm', getUtm(formik.values.style));
  }, [formik.values.style]);

  useEffect(() => {
    if (isCityRink && dallasId && formik.values.siteId !== dallasId) {
      formik.setFieldValue('siteId', dallasId);
    }
    const templateId = getPromoAlertTemplateId(formik.values.siteId, formik.values.style, findTemplate);
    if (templateId) {
      formik.setFieldValue('emailTemplateId', templateId);
    }
  }, [formik.values.style, formik.values.siteId, dallasId, isCityRink, findTemplate]);

  useEffect(() => {
    if (formik?.values?.subject && formik?.values?.subject?.length > 50) {
      formik.setFieldValue('subject', $($.parseHTML(formik?.values?.subject))?.text()?.substring(0, 50));
    }
  }, [formik.values.subject]);

  const isValid = () => {
    try {
      validationSchema.validateSync(formik.values);
      return true;
    } catch (e) {
      return false;
    }
  };

  const shouldShowError = field =>
    Boolean(formik.errors[field] && (showValidationErrors || formik.touched[field] || formik.submitCount > 0));

  const validateForm = async () => {
    const errors = await formik.validateForm();
    formik.setTouched(
      Object.keys(errors).reduce((touched, field) => ({ ...touched, [field]: true }), {}),
      false
    );
    formik.setErrors(errors);
    setShowValidationErrors(Object.keys(errors).length > 0);

    if (Object.keys(errors).length > 0) {
      toast.error('Please fix the highlighted fields before saving.');
      requestAnimationFrame(() => {
        document.querySelector('[aria-invalid="true"] input, input[aria-invalid="true"]')?.focus();
      });
      return false;
    }

    setShowValidationErrors(false);
    return true;
  };

  const submitForm = async onSuccess => {
    if (!(await validateForm())) return false;

    await formik.submitForm();
    if (onSuccess) onSuccess();
    return true;
  };

  const getPage = () => (
    <PageContainer>
      <Breadcrumb>
        <Breadcrumb.Section>
          <Link to={basePath}>{sectionTitle}</Link>
        </Breadcrumb.Section>
        <Breadcrumb.Divider icon="right angle" />
        <Breadcrumb.Section>{id ? `Edit ${emailTitle}` : `Add ${emailTitle}`}</Breadcrumb.Section>
      </Breadcrumb>

      <Menu borderless attached="top">
        <Menu.Item header>{id ? `Edit ${emailTitle}` : `Add ${emailTitle}`}</Menu.Item>
      </Menu>

      <Segment attached>
        <Form onSubmit={formik.handleSubmit} widths="equal" size="tiny" noValidate>
          {showValidationErrors && Object.keys(formik.errors).length > 0 && (
            <Message
              negative
              role="alert"
              aria-live="assertive"
              header="Please fix the following fields"
              list={Object.values(formik.errors)}
            />
          )}
          <Grid>
            <Grid.Column width="8">
              <Form.Field required error={shouldShowError('style')}>
                <label htmlFor="style">Style</label>
                <Dropdown
                  fluid
                  search
                  selection
                  clearable={!isCityRink}
                  disabled={isCityRink}
                  options={
                    isCityRink
                      ? [{ key: 'City Rink', text: 'City Rink', value: 'City Rink' }]
                      : promoAlertStyleOptions
                  }
                  id="style"
                  data-testid="style"
                  label="Style"
                  name="style"
                  required
                  aria-required="true"
                  aria-invalid={shouldShowError('style')}
                  aria-describedby={shouldShowError('style') ? 'style-error' : undefined}
                  error={shouldShowError('style')}
                  value={formik.values.style || ''}
                  onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                />

                {shouldShowError('style') && (
                  <Label id="style-error" role="alert" basic style={errorStyle} pointing content={formik.errors.style} />
                )}
              </Form.Field>

              <Form.Field required error={shouldShowError('siteId')}>
                <label htmlFor="siteId">City</label>
                <Dropdown
                  fluid
                  search
                  selection
                  clearable
                  options={sites || []}
                  id="siteId"
                  label="City"
                  placeholder="City"
                  name="siteId"
                  value={formik.values.siteId || ''}
                  required
                  aria-required="true"
                  aria-invalid={shouldShowError('siteId')}
                  aria-describedby={shouldShowError('siteId') ? 'siteId-error' : undefined}
                  error={shouldShowError('siteId')}
                  disabled={isCityRink}
                  onChange={(e, d) => formik.setFieldValue('siteId', d.value)}
                />
                {shouldShowError('siteId') && (
                  <Label
                    id="siteId-error"
                    role="alert"
                    basic
                    style={errorStyle}
                    pointing
                    content={formik.errors.siteId}
                  />
                )}
                {isCityRink && !shouldShowError('siteId') && (
                  <Message
                    info={Boolean(dallasId)}
                    negative={!dallasId}
                    size="mini"
                    content={
                      dallasId
                        ? 'City Rink emails are sent from the Dallas property.'
                        : 'The Dallas site is unavailable. Contact an administrator before saving.'
                    }
                  />
                )}
              </Form.Field>

              <Form.Field>
                <TextField
                  name="subject"
                  formik={formik}
                  required
                  value={formik.values.subject || ''}
                  onChange={e => {
                    if (e?.target?.value) {
                      e.target.value = $($.parseHTML(e.target.value)).text().substring(0, 50);
                    }
                    formik.handleChange(e);
                  }}
                  error={shouldShowError('subject')}
                  errorMessage={formik.errors.subject}
                  label={`Subject line (Characters: ${formik.values?.subject?.length || 0})`}
                />
              </Form.Field>
              <Form.Field>
                <TextField
                  name="title"
                  formik={formik}
                  value={formik.values.title || ''}
                  onChange={e => {
                    if (e?.target?.value) {
                      e.target.value = e.target.value.substring(0, 60);
                    }
                    formik.handleChange(e);
                  }}
                  error={Boolean(formik.errors.title)}
                  errorMessage={formik.errors.title}
                  label={`Title (Characters: ${formik?.values?.title?.length || 0})`}
                />
              </Form.Field>
              <Grid style={{ padding: `1rem` }}>
                <strong style={{ marginLeft: -15 }}>Photo</strong>

                {formik?.values?.photoUrl && (
                  <Grid.Row>
                    <Image
                      src={formik.values.photoUrl || ''}
                      size="medium"
                      as="a"
                      href={formik.values.photoUrl || ''}
                      rel="noreferrer"
                      target="_blank"
                    />
                  </Grid.Row>
                )}

                <Grid.Row>
                  <Form.Field>
                    <PhotoSearch
                      handleSelect={({ id, original }) =>
                        formik.setFieldValue('photoUrl', 'https://res.cloudinary.com/culturemap-com/' + original)
                      }
                    />
                    {formik.errors.photoUrl && (
                      <Label basic style={errorStyle} pointing content={formik.errors.photoUrl} />
                    )}
                  </Form.Field>
                </Grid.Row>
              </Grid>

              <Form.Field error={Boolean(formik.errors.photoType)}>
                <label htmlFor="style">Photo type</label>
                <Dropdown
                  fluid
                  search
                  selection
                  clearable
                  options={['No crop', '4x3', '16x9'].map(item => ({
                    text: item,
                    value: item,
                    key: item,
                  }))}
                  id="photoType"
                  data-testid="photoType"
                  name="photoType"
                  error={Boolean(formik.errors.photoType)}
                  value={formik.values.photoType || ''}
                  onChange={(e, d) => formik.setFieldValue(d.name, d.value)}
                />
                {shouldShowError('photoType') && (
                  <Label basic style={errorStyle} pointing content={formik.errors.photoType} />
                )}
              </Form.Field>

              <Form.Field>
                <TextField
                  name="buttonLabel"
                  formik={formik}
                  value={formik.values.buttonLabel || ''}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.buttonLabel)}
                  errorMessage={formik.errors.buttonLabel}
                  label={`Button label`}
                />
              </Form.Field>
              <Form.Field>
                <TextField
                  name="buttonUrl"
                  formik={formik}
                  value={formik.values.buttonUrl || ''}
                  onChange={formik.handleChange}
                  required={isCityRink}
                  error={shouldShowError('buttonUrl')}
                  errorMessage={formik.errors.buttonUrl}
                  label="Button URL"
                />
              </Form.Field>

              {isCityRink && (
                <>
                  <ColorPickerField
                    name="buttonColor"
                    label="Button color"
                    help="Sets the background color of the City Rink email CTA button."
                    value={formik.values.buttonColor}
                    defaultColor={CITY_RINK_DEFAULT_BUTTON_COLOR}
                    error={shouldShowError('buttonColor')}
                    errorMessage={formik.errors.buttonColor}
                    setFieldValue={formik.setFieldValue}
                    errorStyle={errorStyle}
                  />
                  <ColorPickerField
                    name="buttonTextColor"
                    label="Button text color"
                    help="Sets the text color of the City Rink email CTA button."
                    value={formik.values.buttonTextColor}
                    defaultColor={CITY_RINK_DEFAULT_BUTTON_TEXT_COLOR}
                    error={shouldShowError('buttonTextColor')}
                    errorMessage={formik.errors.buttonTextColor}
                    setFieldValue={formik.setFieldValue}
                    errorStyle={errorStyle}
                  />
                </>
              )}

              <Form.Field error={Boolean(formik.errors.body)}>
                <label>Body</label>
                <ReactQuill
                  theme="snow"
                  ref={quill}
                  modules={modules}
                  value={formik.values.body || ''}
                  onChange={html => {
                    formik.setFieldValue('body', html);
                  }}
                  style={{ height: 300 }}
                />
                {formik.errors.body && <Message negative size="small" content={formik.errors.body} />}
              </Form.Field>

              <br />
              <br />
              <br />

              <Segment>
                <Header as="h4">Website Footer Scheduling</Header>
                <p>
                  Use the start and end dates below to schedule when this promo alert will appear as a banner on the
                  website.
                </p>
                <Form.Field>
                  <label>Start date</label>
                  <DateTimeInput
                    closable={true}
                    name="startDate"
                    popupPosition="bottom center"
                    placeholder="Start date"
                    timeFormat="ampm"
                    minDate={moment().format('L')}
                    value={formik.values.startDate || ''}
                    iconPosition="left"
                    dateFormat="YYYY-MM-DD"
                    dateTimeFormat="YYYY-MM-DD @ h:mm a"
                    onChange={(e, { value }) => formik.setFieldValue('startDate', value)}
                  />
                </Form.Field>

                <Form.Field>
                  <label>End date</label>
                  <DateInput
                    closable={true}
                    name="endDate"
                    popupPosition="bottom center"
                    placeholder="End date"
                    value={formik.values.endDate || ''}
                    iconPosition="left"
                    dateFormat="YYYY-MM-DD"
                    onChange={(e, { value }) => formik.setFieldValue('endDate', value)}
                  />
                </Form.Field>
              </Segment>

              <Segment>
                <Header as="h4">Email Campaign Scheduling</Header>
                <p>
                  Use the send date and time below to schedule when this promo alert will be sent to your audience via
                  email.
                </p>
                <Form.Field required error={shouldShowError('sendDate')}>
                  <label>Send date</label>
                  <DateInput
                    closable={true}
                    name="sendDate"
                    popupPosition="bottom center"
                    placeholder="Send date"
                    value={formik.values.sendDate || ''}
                    iconPosition="left"
                    dateFormat="YYYY-MM-DD"
                    required
                    aria-required="true"
                    aria-invalid={shouldShowError('sendDate')}
                    aria-describedby={shouldShowError('sendDate') ? 'sendDate-error' : undefined}
                    onChange={(e, { value }) => formik.setFieldValue('sendDate', value)}
                  />
                  {shouldShowError('sendDate') && (
                    <Label
                      id="sendDate-error"
                      role="alert"
                      basic
                      style={errorStyle}
                      pointing
                      content={formik.errors.sendDate}
                    />
                  )}
                </Form.Field>
                <Form.Field>
                  <label>Send time</label>

                  <Select
                    fluid
                    options={EMAIL_SEND_TIMES}
                    id="sendTime"
                    name="sendTime"
                    clearable
                    value={formik.values.sendTime || ''}
                    error={Boolean(formik.errors.sendTime)}
                    onChange={(e, { value }) => formik.setFieldValue('sendTime', value ? value : null)}
                  />

                  {formik.errors.sendTime && (
                    <Label basic style={errorStyle} pointing content={formik.errors.sendTime} />
                  )}
                </Form.Field>
              </Segment>
              <Form.Field>
                <TextField
                  name="utm"
                  formik={formik}
                  value={formik.values.utm || ''}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.utm)}
                  errorMessage={formik.errors.utm}
                  label="UTM campaign"
                />
              </Form.Field>
            </Grid.Column>
          </Grid>
        </Form>
        <br />
        <br />
      </Segment>

      <Container fluid style={{ marginTop: 10 }}>
        <Button
          positive
          content="Save"
          onClick={() => submitForm(() => setTimeout(() => history.push(basePath), 2000))}
        />
        <Button
          positive
          // disabled={formik.isSubmitting || !formik.isValid}
          content="Clone"
          onClick={async () => {
            if (!(await validateForm())) return;
            const { id, mailchimpCampaignId, ...data } = formik.values;
            if (id) clonePromoAlert({ ...data });
          }}
        />
        <Button
          // disabled={formik.isSubmitting || !formik.isValid}
          positive
          content="Save and continue editing"
          onClick={() => submitForm()}
        />

        <Button
          icon="binoculars"
          content="Save & Preview"
          target="_blank"
          labelPosition="left"
          disabled={!isValid()}
          onClick={() =>
            submitForm(() => {
              setTimeout(() => {
                window.open(`${SERVER_URL}/api/promo-alert/email/${formik.values.id}`, '_blank');
              }, 2000);
            })
          }
        />

        <Button
          icon="envelope"
          content="Send Test Email"
          disabled={!isValid()}
          onClick={() => getPromoAlertTestEmail(formik.values.id)}
        />

        <Button
          icon="envelope"
          content="Schedule Email"
          disabled={
            !formik.values.sendTime ||
            !formik.values.sendDate ||
            !isValid() ||
            !formik.values.mailchimpCampaignId ||
            currentPromoAlert?.isScheduled
          }
          onClick={async () => {
            await formik.setFieldValue('isScheduled', true);
            submitForm();
          }}
        />

        {/* <Button
          icon="binoculars"
          as="a"
          content="Preview"
          disabled={!formik.isValid || formik.isSubmitting || !id}
          onClick={() => {
            setLoading(true);
            formik.handleSubmit();
            setTimeout(() => {
              window.open(`${SERVER_URL}/api/promo-alert/email/${currentPromoAlert.id}`, '_blank');
              setLoading(false);
            }, 1 * 1000);
          }}
        /> */}

        <Popup
          closeOnPortalMouseLeave
          trigger={
            <Button icon="trash" disabled={formik.values.isScheduled} negative content="Delete" floated="right" />
          }
          content={
            <Button
              color="green"
              content="Are you sure?"
              onClick={() => {
                campaignApi.unschedule(id).then(() => {
                  deletePromoAlertById(id, basePath);
                });
              }}
            />
          }
          on="click"
          position="bottom left"
        />
      </Container>

      <br />
      <MailChimpSection id={id} user={user} formik={formik} />
    </PageContainer>
  );

  return id ? <>{currentPromoAlert?.id === id && getPage()}</> : <>{getPage()}</>;
};

const mapStateToProps = state => ({
  firm: selectors.getCurrentFirm(state),
  cities: selectors.getCityOptions(state),
  sites: selectors.getSiteOptions(state),
  topPostResults: selectors.getTopPosts(state),
  searchPostResults: selectors.getSearchPosts(state),
  currentPromoAlert: selectors.getCurrentPromoAlert(state),
  dallasId: selectors.getDallasId(state),
  user: selectors.users.current(state),
  dayOptions: selectors.getDayOptions(state),
  findTemplate: selectors.templates.find(state),
});

const mapDispatchToProps = dispatch => ({
  addPromoAlert: bindActionCreators(actions.campaign.addPromoAlert, dispatch),
  clonePromoAlert: bindActionCreators(actions.campaign.clonePromoAlert, dispatch),
  clearRecentPosts: bindActionCreators(actions.campaign.clearRecentPosts, dispatch),
  updatePromoAlert: bindActionCreators(actions.campaign.updatePromoAlert, dispatch),
  getTopPosts: bindActionCreators(actions.campaign.getTopPosts, dispatch),
  searchPosts: bindActionCreators(actions.campaign.searchDigests, dispatch),
  getPromoAlertById: bindActionCreators(actions.campaign.getPromoAlertById, dispatch),
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  deletePromoAlertById: bindActionCreators(actions.campaign.deletePromoAlertById, dispatch),
  getPromoAlertTestEmail: bindActionCreators(actions.campaign.getPromoAlertTestEmail, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPromoAlert);
